import Trarnslate from "../../Atollon/Translation";

export const required = value => value ? undefined : 'Povinné';
export const email = value => !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Neplatný formát e-mail adresy' : undefined;
export const isNumeric = value => isNaN(Number(value)) ? 'Zadejte číselnou hodnotu' : undefined;
export const isAtollonInstanceId = value => /^[0-9]+$/.test(value) ? undefined: 'Zadejte číselnou hodnotu';
export const emptyOrgreaterEqual0 = value => !value || value === "" || (!isNaN(Number(value)) && Number(value) >= 0) ? undefined : "Minimum je 0";
export const isAtollonInstanceIdent = value => /^[a-z0-9]*$/.test(value)? undefined: 'Jméno musí obsahovat pouze malá písmena a čísla';



// WEBPACK FOOTER //
// ./src/components/form/Validation.js